/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

const StyledSvg = styled.svg``;

interface CheckIconProps {
  color?: string;
  stroke?: string;
  className?: string;
}

export const Check: React.FC<CheckIconProps> = ({ color, stroke, className }) => (
  <StyledSvg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 12.2L10.3 16.4 18.4 6.1"
      stroke={stroke || 'currentColor'}
      strokeWidth="1"
      fill={color}
      fillRule="evenodd"
    />
  </StyledSvg>
);

export default Check;
